import { zodResolver } from "@hookform/resolvers/zod";
import {
  Button,
  TickS,
} from "@totalenergiescode/mobility-business-rev-design-system";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { RoundedTopLeftContainer } from "@/components/containers/RoundedTopLeftContainer/component";
import { getTemplates } from "@/components/FormData/templates/HardCodedTemplate/mocks/templates";
import { StyledForm } from "@/components/formDataInjector/styles";
import { ControlledSelect } from "@/components/shared/ControlledSelect/component";

import {
  StyledButtonContainer,
  StyledDrawer,
  StyledDrawerInnerContainer,
  StyledHeaderText,
  StyledInputContainer,
  StyledSection,
} from "./styles";
import type {
  GetHardCodedTemplateFormType,
  HardCodedTemplateSelectorProps,
} from "./types";
import { getHardCodedTemplateFormSchema } from "./types";

const HardCodedTemplate = ({
  isOpen,
  onClose,
  onChange,
}: HardCodedTemplateSelectorProps) => {
  const { t: tFormData } = useTranslation("formData");
  const { control, handleSubmit, getValues } =
    useForm<GetHardCodedTemplateFormType>({
      resolver: zodResolver(getHardCodedTemplateFormSchema),
      defaultValues: {
        template: "",
      },
    });
  const [templates, setTemplates] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    getTemplates().then((value) => {
      setTemplates(value);
    });
  }, []);

  const selectTemplate = () => {
    onChange(getValues("template"));
    onClose();
  };

  const options = Array.from(templates.entries()).map(([key, _value]) => ({
    value: _value,
    label: key,
  }));

  return (
    <StyledDrawer
      dataTestId={"formdata__hardcoded-template-drawer"}
      isOpen={isOpen}
      onClose={onClose}
    >
      <StyledHeaderText variant='title5'>
        {tFormData("formData.hardcodedTemplate.title")}
      </StyledHeaderText>

      <RoundedTopLeftContainer>
        <StyledDrawerInnerContainer>
          <StyledForm onSubmit={handleSubmit(selectTemplate)}>
            <StyledSection>
              <StyledInputContainer>
                <ControlledSelect
                  control={control}
                  name='template'
                  namespace='formData'
                  selectProps={{
                    className: "select-hardcoded-template",
                    type: "options",
                    options: options,
                    label: tFormData("formData.hardcodedTemplate.ledgerType"),
                    dataTestId:
                      "formdata__hardcoded-template-form_template-select",
                  }}
                />
              </StyledInputContainer>
            </StyledSection>

            <StyledButtonContainer
              sx={{ marginTop: "40px", justifyContent: "space-between" }}
            >
              <Button
                variant='secondary'
                isLowercase
                buttonText={tFormData(
                  "formData.hardcodedTemplate.buttons.cancel",
                )}
                onClick={onClose}
              />
              <Button
                leftIcon={<TickS width={25} height={25} color='white' />}
                variant='primary'
                isLowercase
                type='submit'
                buttonText={tFormData(
                  "formData.hardcodedTemplate.buttons.save",
                )}
                onClick={selectTemplate}
              />
            </StyledButtonContainer>
          </StyledForm>
        </StyledDrawerInnerContainer>
      </RoundedTopLeftContainer>
    </StyledDrawer>
  );
};

export default HardCodedTemplate;
